// Диапазон дат в формате YYYY-MM-DD (локальный календарный день — совпадает с
// value нативного input[type=date] и с формой в URL отчёта).
export interface PeriodValue {
  from: string
  to: string
}

export type PresetKind = 'today' | 'week' | 'month' | 'quarter'

export const PRESETS: { kind: PresetKind; label: string }[] = [
  { kind: 'today', label: 'Сегодня' },
  { kind: 'week', label: 'Неделя' },
  { kind: 'month', label: 'Месяц' },
  { kind: 'quarter', label: 'Квартал' },
]

const pad = (n: number) => String(n).padStart(2, '0')

export function fmtDay(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

// Понедельник — начало недели (ru-локаль): getDay 0=вс..6=сб → сдвиг до пн.
function weekStart(d: Date): Date {
  const offset = (d.getDay() + 6) % 7
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() - offset)
}

export function presetRange(kind: PresetKind, today: Date = new Date()): PeriodValue {
  switch (kind) {
    case 'today':
      return { from: fmtDay(today), to: fmtDay(today) }
    case 'week': {
      const start = weekStart(today)
      const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6)
      return { from: fmtDay(start), to: fmtDay(end) }
    }
    case 'month': {
      const start = new Date(today.getFullYear(), today.getMonth(), 1)
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      return { from: fmtDay(start), to: fmtDay(end) }
    }
    case 'quarter': {
      const qMonth = Math.floor(today.getMonth() / 3) * 3
      const start = new Date(today.getFullYear(), qMonth, 1)
      const end = new Date(today.getFullYear(), qMonth + 3, 0)
      return { from: fmtDay(start), to: fmtDay(end) }
    }
  }
}

// Текущий месяц — дефолтный период отчёта (дефолт живёт вне URL).
export function currentMonthPeriod(today: Date = new Date()): PeriodValue {
  return presetRange('month', today)
}

// Какому пресету соответствует диапазон, либо 'custom' (произвольный).
export function matchPreset(value: PeriodValue, today: Date = new Date()): PresetKind | 'custom' {
  for (const { kind } of PRESETS) {
    const r = presetRange(kind, today)
    if (r.from === value.from && r.to === value.to) return kind
  }
  return 'custom'
}

// Период валиден, когда обе даты заданы и конец не раньше начала.
export function periodValid(value: PeriodValue): boolean {
  return Boolean(value.from) && Boolean(value.to) && value.from <= value.to
}
